import { Injectable } from '@angular/core';
import { ApiService } from '../core/api.service';
import { AppService } from '../core/app.service';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import * as moment from 'moment';
import {
  Concert,
  PromotionPure,
  SubConcert,
} from 'src/app/models/(item)/concert/Concert.model';
import { BasketConcertItem } from 'src/app/models/(basket)/Basket.model';
@Injectable({
  providedIn: 'root',
})
export class ConcertService {
  concerts$: BehaviorSubject<Concert[]> = new BehaviorSubject<Concert[]>(null);
  concertsPure$: BehaviorSubject<Concert[]> = new BehaviorSubject<Concert[]>(
    null,
  );
  promotionPureList$: BehaviorSubject<PromotionPure[]> = new BehaviorSubject<
    PromotionPure[]
  >([]);

  subConcertsPure$: BehaviorSubject<SubConcert[]> = new BehaviorSubject<
    SubConcert[]
  >(null);
  basketConcertItem$: BehaviorSubject<BasketConcertItem> =
    new BehaviorSubject<BasketConcertItem>(null);
  constructor(
    private apiService: ApiService,
    private appService: AppService,
  ) {}

  async getConcertData() {
    this.appService.progressBool();
    await this.apiService
      .getConcertData(moment().format('YYYY-MM-DD'), true)
      .then((data) => {
        data = JSON.parse(data[0][0].Return);
        let concertPure: SubConcert[] = data.TICKETS;
        this.promotionPureList$.next(data.PROMOTIONS ?? []);
        this.subConcertsPure$.next(concertPure);
        this.appService.extensionScripts(data.EXTENTIONSCRIPT);
        this.mappingData(concertPure);
        this.appService.extraProducts$.next(data.EXTRAPRODUCTS);
        this.appService.setWebsite(
          JSON.parse(data.SETTINGS[0].SETTINGS),
          data.COMPANYINFO[0],
          data.LANGUAGES,
        );
        this.appService.progressBool();
      })
      .catch((error) => {
        console.log('Error', error);
      });
  }
  private destroy$ = new Subject<void>();
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  mappingData(data: SubConcert[]) {
    if (!Array.isArray(data)) data = [];
    data = data.filter((x) => x.ISLOCAL == 1 && x.STARTDATE != null);
    let concerts: Concert[] = [];
    //gelen datalari SUBTICKETID gore gruplayip concert'e atiyoruz
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      let concert: Concert = concerts.find(
        (concert) => concert.SUBTICKETID == element.SUBTICKETID,
      );
      if (concert) {
        concert.SUBCONCERTS.push(element);
      } else {
        concerts.push({
          SUBTICKETID: element.SUBTICKETID,
          SUBTICKETNAME: element.SUBTICKETNAME,
          ISLOCAL: element.ISLOCAL,
          CURRENCY: element.CURRENCY,
          CURRENCYID: element.CURRENCYID,
          PRODUCTURL: element.PRODUCTURL,
          SEOURL: this.seoUrlGenerate(element.SUBTICKETNAME),
          GROUPIMAGEURL: element.GROUPIMAGEURL,
          GROUPID: element.GROUPID,
          GROUPNAME: element.GROUPNAME,
          GROUPSEOURL: this.seoUrlGenerate(element.GROUPNAME),
          SUBCONCERTS: [element],
        });
      }
    }

    this.concerts$.next(concerts);
    this.concertsPure$.next(concerts);
  }

  seoUrlGenerate(text) {
    var trMap = {
      ç: 'c',
      Ç: 'C',
      ğ: 'g',
      Ğ: 'G',
      ş: 's',
      Ş: 'S',
      ü: 'u',
      Ü: 'U',
      ı: 'i',
      İ: 'I',
      ö: 'o',
      Ö: 'O',
    };
    for (var key in trMap) {
      text = text?.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
    }
    return text
      ?.replace(/[^-a-zA-Z0-9\s]+/gi, '')
      ?.replace(/\s/gi, '')
      ?.replace(/[-]+/gi, '-');
  }
  getSeoUrlToConcert(seoUrl: string) {
    if (this.concerts$.value) {
      return this.concerts$.value.find((x) => x.SEOURL == seoUrl);
    } else {
      this.getConcertData();
      return this.concerts$.value.find((x) => x.SEOURL == seoUrl);
    }
  }
  async execPromotionCode(productId: number, promotionCode: string) {
    return await this.apiService
      .execPromotionCode(productId, promotionCode)
      .toPromise();
  }
  reset() {
    this.concerts$.next(null);
    this.basketConcertItem$.next(null);
  }
}
